import { onMounted, onUnmounted } from "vue";
import { qModEvent } from "@/utils/eventemitter";
export const registerEvents = compName => {
    onMounted(() => {
        qModEvent({
            type: "COMPONENT",
            event: "MOUNTED",
            name: compName,
        });
    });
    onUnmounted(() => {
        qModEvent({
            type: "COMPONENT",
            event: "UNMOUNTED",
            name: compName,
        });
    });
};
// onUnmounted(() => target.removeEventListener(event, callback))
